import Swal from 'sweetalert2';

export default class SurveysAccessesIndex {

  constructor() {}

  render() {
    let accountUrl = $('body').attr('data-account-url');
    let surveySlug = $('#survey_invitation_token').attr('data-slug');

    // On selection - multiple potential actions to take
    $('#users_search').bind('typeahead:select typeahead:autocomplete', function(ev, suggestion) {
      ev.preventDefault();
      let userId = suggestion.record_id;
      let url = '/' + accountUrl + '/surveys/' + surveySlug + '/accesses';
      let params = {};
      params['user_id'] = userId;
      $.ajax({
        type: 'POST',
        dataType: 'application/json',
        url: url + '?' + $.param(params),
        complete(result) { 
          $('#survey_accesses_table').DataTable().ajax.reload();
          $('#users_search').typeahead('val', '');
          $('#users_search').blur();
        }
      });
    })

  }

}
